export const deliveryListFilter = [
  { id: "delivery_order", label: "Delivery Number" },
  { id: "shipping_case", label: "Shipping Case Number" },
  { id: "customer", label: "Customer" },
  { id: "supplier", label: "Supplier" },
  { id: "destination", label: "Destination" },
];

export const CONTACTOR = [
  { id: "SEAWAY", label: "SEAWAY" },
  { id: "CUSTOMER", label: "CUSTOMER" },
];

export const STATUSES = [
  { id: "PENDING", label: "Pending" },
  { id: "EXECUTED", label: "Executed" },
  { id: "CANCELED", label: "Canceled" },
];

export const ORDER_LIST_FILTERS = [
  {
    field: "label",
    label: "Delivery Order",
    control: "dynamic",
    multi: true,
    api: "/api/dropdown/delivery-info?field_name=label",
    mapperKey: "reference_order",
    valueKey: "label",
    query: "value",
  },
  {
    field: "shipping_case",
    label: "Shipping Case",
    control: "dynamic",
    multi: true,
    api: "/api/shipping-cases/short",
    mapperKey: "shipping_case",
    query: "title",
  },
  {
    field: "delivery__transport_contactor",
    label: "Transport Contractor",
    control: "autocomplete",
    multi: true,
    options: CONTACTOR,
  },
  {
    field: "transport_contactor_customer",
    label: "Transport Contractor Customer",
    control: "dynamic",
    multi: true,
    api: "/api/dropdown/customers?entity=DL_TC_CUSTOMER",
    conditional: {
      field: "delivery__transport_contactor",
      value: "CUSTOMER",
    },
  },
  {
    field: "truck_supplier__id",
    label: "Carrier",
    control: "dynamic",
    multi: true,
    api: "/api/dropdown/suppliers?entity=DI_CARRIER",
  },
  {
    field: "depositor__id",
    label: "Sender",
    control: "dynamic",
    multi: true,
    api: "/api/dropdown/customers?entity=DI_DEPOSITOR",
  },
  {
    field: "consignee__id",
    label: "Consignee",
    control: "dynamic",
    multi: true,
    api: "/api/dropdown/customers?entity=DI_CONSIGNEE",
  },
  {
    field: "loading_date",
    label: "Date Of Loading",
    control: "datepicker",
  },
  {
    field: "discharge_address__id",
    label: "Destination",
    control: "dynamic",
    multi: true,
    api: "/api/dropdown/customer-addresses?entity=DI_DESTINATION",
    query: "destination",
  },
  {
    field: "delivery_truck__truck_plate",
    label: "Truck plate",
    control: "dynamic",
    multi: true,
    api: "/api/dropdown/delivery-trucks?field_name=truck_plate",
    mapperKey: "truck_plate",
    valueKey: "label",
    query: "value",
  },
  {
    field: "status",
    label: "Status",
    control: "autocomplete",
    options: STATUSES,
    multi: true,
  },
  {
    field: "loading__ddt_number",
    label: "DDT Number",
    control: "dynamic",
    multi: true,
    api: "/api/dropdown/loadings?field_name=ddt_number",
    mapperKey: "ddt_number",
    valueKey: "label",
    query: "value",
  },
  {
    field: "loading__ddt_created_at",
    label: "DDT Date",
    control: "datepicker",
  },
];
